import { Paper, Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: '#f9fafb',
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const StyledRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  '> *': { flex: 1 },
  gap: theme.spacing(2),
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  boxShadow: 'none',
  backgroundColor: '#ffffff',
  padding: theme.spacing(1.5, 2),
}));

export const StyledPaperLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  color: '#6b7280',
  [theme.breakpoints.up('lg')]: {
    whiteSpace: 'nowrap',
  },
}));

export const StyledPaperValue = styled(Typography)(() => ({
  color: '#6d77c8',
  fontSize: '1.5rem',
  lineHeight: '2rem',
  fontWeight: 700,
}));

export const StyledTotalPricePaper = styled(StyledPaper)(({ theme }) => ({
  backgroundColor: '#f0f2ff',
  border: '1px solid',
  borderColor: '#c1c8ff',
  gap: theme.spacing(2),
}));

export const StyledTotalPricePaperValue = styled(StyledPaperValue)(() => ({
  fontSize: '3rem',
  lineHeight: 1,
}));
